/**
 * 超级会员卡片（授信环节）天启埋点统一定义
 * 抽离事件 ID、参数构建与上报方法，保证组件逻辑干净
 */
import Vue from 'vue';
import { ubtPageButtonNew, ubtModuleExposeNew, ubtSendError } from '@/shared/utils/ubt';
import { SuperMemberSourceEnum } from '@/api/rights/types';

/** 埋点上下文：组件实例或 pageId 字符串，与 ubt 方法首参类型一致 */
type UbtContext = InstanceType<typeof Vue> | string;

/** 权益卡片埋点公用参数（与接口 rightInfo + 来源、商品一致） */
export interface TqParams {
  supplierCode?: string;
  sellPrice?: string;
  packageId?: string;
  packageType?: number;
  from: SuperMemberSourceEnum;
  productId: number[];
  packageBuyStatus?: number;
}

/** 从 rightInfo 与 props 构建 tq 公用参数 */
export function buildTqParams(
  rightInfo: Record<string, unknown> | null,
  from: SuperMemberSourceEnum,
  commoditys: number[],
): TqParams {
  const info = rightInfo || {};
  const {
    supplierCode, packageId, packageType, packageBuyStatus, sellPrice,
  } = info;
  return {
    supplierCode: supplierCode as string | undefined,
    sellPrice: sellPrice as string | undefined,
    packageId: packageId as string | undefined,
    packageType: packageType as number | undefined,
    from,
    productId: commoditys,
    packageBuyStatus: packageBuyStatus as number | undefined,
  };
}

/** 埋点事件 ID：协议勾选 */
export const TQ_EVENT_AGREEMENT_CHECK = 'finance_loan_packageEntry_agreementCheck';

/** 埋点模块 ID：会员卡片曝光 */
export const TQ_MODULE_PACKAGE_ENTRY = 'finance_loan_packageEntry';

/** 埋点事件 ID：点击查看协议 */
export const TQ_EVENT_AGREEMENT = 'finance_loan_packageEntry_agreement';

/** 埋点事件 ID：会员获取展示异常 */
export const TQ_EVENT_MEMBER_GETSHOW = 'finance_loan_credit_memberGetshow';

/** 上报：协议勾选（ctx 为组件实例或 pageId 字符串） */
export function reportAgreementCheck(ctx: unknown, params: TqParams): void {
  if (ctx) {
    ubtPageButtonNew(ctx as UbtContext, TQ_EVENT_AGREEMENT_CHECK, { ...params });
  }
}

/** 上报：会员卡片模块曝光 */
export function reportModuleExpose(ctx: unknown, params: TqParams): void {
  if (ctx) {
    ubtModuleExposeNew(ctx as UbtContext, TQ_MODULE_PACKAGE_ENTRY, { ...params });
  }
}

/** 上报：点击查看协议 */
export function reportAgreement(ctx: unknown, params: TqParams): void {
  if (ctx) {
    ubtPageButtonNew(ctx as UbtContext, TQ_EVENT_AGREEMENT, { ...params });
  }
}

/** 上报：会员获取展示异常（接口/逻辑错误） */
export function reportMemberGetshowError(ctx: unknown, err: unknown): void {
  ubtPageButtonNew(
    (ctx as UbtContext) || TQ_MODULE_PACKAGE_ENTRY,
    TQ_EVENT_MEMBER_GETSHOW,
    { err: JSON.stringify(err) },
  );
}

/** 上报：强制阅读未读但发起下单（业务监控） */
export function reportForceReadError(): void {
  ubtSendError({
    name: 'right_force_read',
    message: 'needReadContract but not read',
    stack: SuperMemberSourceEnum.CREDIT_AGREEMENT,
  });
}
